import { Vue, Component } from "vue-property-decorator";
import { CommonServices } from "../../services/common.services";
import PhoneSocket from "./phone-socket";
import { storeModules } from "../../store";
import { namespace, Action } from "vuex-class";
import { APP_CONFIG_MODULE_TYPES } from "../../store/config/app-config-types.store";
import { IAllocloudWebsocketPayloadModel, IPhoneConfigModel } from "../../models/person/phone-person-info.model";
import EventBus from "../../utils/event-bus";
import { EVENT_BUS, NOTIFICATION_CENTER_TYPES } from "../../common/constants";
import { NotificationItemModel } from "../../models/common/notification-center.model";

const AppConfigAction = namespace(storeModules.AppConfig, Action);
@Component({
    name: "PhoneListener",
    template: require("./template.html"),
    components: {
    }
})
export default class PhoneListener extends Vue {
    @AppConfigAction(APP_CONFIG_MODULE_TYPES.SET_USER_CONFIG) private storeSetUserConfig: ({key, value}: {key: string, value: any}) => void;
    @AppConfigAction(APP_CONFIG_MODULE_TYPES.SET_SYSTEM_CONFIG) private storeSetSystemConfig: ({key, value}: {key: string, value: any}) => void;

    private commonService = new CommonServices();

    private loadPhoneConfigsInfomation() {
        this.commonService.getUserPhoneConfigs().then(data => {
            const { Site3CxConfig } = data;
            if (Site3CxConfig) {
                this.storeSetSystemConfig({
                    key: 'Site3CxConfig',
                    value: Site3CxConfig
                })
            }
        }).catch(err => {
            console.log(err);
        })
    }

    private loadPhonePermissionConfig() {
        this.commonService.getUserPhonePermission().then(data => {
            const PhoneConfig: IPhoneConfigModel = data.PhoneConfig;
            if (PhoneConfig) {
                const enable3CX = PhoneConfig.Use3CXOutGoingCall;
                if (enable3CX) {
                    this.loadPhoneConfigsInfomation();
                }
                this.storeSetUserConfig({
                    key: "Use3CXOutGoingCall",
                    value: PhoneConfig.Use3CXOutGoingCall
                })
                this.storeSetUserConfig({
                    key: "Show3CXIncomingCall",
                    value: PhoneConfig.Show3CXIncomingCall
                })
                this.storeSetUserConfig({
                    key: "UseAlloCloudPhone",
                    value: PhoneConfig.UseAlloCloudPhone
                })
                this.storeSetUserConfig({
                    key: "TelSmart",
                    value: PhoneConfig.TelSmart
                })
            }
        }).catch(err => {
            console.log(err)
        })
    }

    async mounted() {
        try {
            const data = await this.commonService.getUserPhoneDevice();
            if (data) {
                const { WsEventUrl, VoipToken } = data;
                if (WsEventUrl && VoipToken) {
                    const phoneSocket = new PhoneSocket(`${WsEventUrl}?auth_token=${VoipToken}`);
    
                    try {
                        await phoneSocket.handleConnect();
                        phoneSocket.socket.addEventListener('message', (event) => {
                            const eventData = JSON.parse(event.data);
                            const method: string = eventData.METHOD;
                            const messagePayload: IAllocloudWebsocketPayloadModel = eventData.PAYLOAD;
    
                            if (method === 'NOTIFY') {
                                const fromNumber = messagePayload.From;
                                EventBus.$emit(EVENT_BUS.NOTIFICATION.NOTIFICATION_PUSH_ITEM, 
                                    new NotificationItemModel<{ phoneNumber: string, data: object, isCallOut: boolean }>({
                                        type: NOTIFICATION_CENTER_TYPES.PHONE_CALL,
                                        payloadData: {
                                            phoneNumber: fromNumber,
                                            data: null,
                                            isCallOut: false
                                        }
                                    })
                                );
                            }
                        });
                    } catch (err) {
                        console.log(`connect to ${WsEventUrl} failed: `, err);
                    }
                }
            }
        } catch (error) {
            console.error('Error getting user phone device:', error);
        }
    
        this.loadPhonePermissionConfig();
    }
}